(function () {
  'use strict';

  /* Sticky header shadow */
  function initHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var toggle = header.querySelector('.menu-toggle');
    var nav = header.querySelector('.nav');
    if (toggle && nav && !toggle.dataset.bound) {
      toggle.dataset.bound = '1';
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.querySelector('.icon-open').hidden = open;
        toggle.querySelector('.icon-close').hidden = !open;
      });
      nav.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          if (nav.classList.contains('is-open')) toggle.click();
        });
      });
    }
  }

  /* Reveal on scroll */
  var io = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window) || document.body.dataset.animations === 'false') {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* Animated counters: <span data-count="1200" data-suffix="+"> */
  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-count]:not([data-counted])');
    var run = function (el) {
      el.setAttribute('data-counted', '1');
      var target = parseFloat(el.getAttribute('data-count'));
      if (isNaN(target)) return;
      var decimals = (el.getAttribute('data-count').split('.')[1] || '').length;
      var start = null, dur = 1600;
      var step = function (ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(decimals);
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); cio.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { cio.observe(el); });
  }

  /* FAQ: close siblings when one opens */
  function initFaq(root) {
    (root || document).querySelectorAll('.faq[data-single]').forEach(function (faq) {
      faq.querySelectorAll('details').forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          faq.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  function initAll(root) {
    initHeader();
    initReveal(root);
    initCounters(root);
    initFaq(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    e.target.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var d = e.target.closest('details');
    if (d) d.open = true;
  });
})();
